<template>
  <date-picker
    v-model="model"
    prefix-class="datetime"
    range
    :disabled="disabled"
    :type="
      type == 'time' || type == 'minutes' || type == 'hours' ? 'time' : type
    "
    value-type="format"
    :format="
      type == 'datetime'
        ? 'YYYY-MM-DD HH:mm:ss'
        : type == 'time'
        ? 'HH:mm:ss'
        : type == 'minutes'
        ? 'HH:mm'
        : type == 'hours'
        ? 'HH'
        : 'YYYY-MM-DD'
    "
    :shortcuts="
      type == 'time' || type == 'minutes' || type == 'hours' || hideShortcuts
        ? []
        : $consts.dateTimeRangeShortcuts
    "
    :show-time-panel="showTimePanel"
    @close="showTimePanel = false"
  >
    <template v-slot:header> <slot name="header"></slot> </template>
    <!-- <template v-slot:sidebar> sidebar </template> -->
    <template v-slot:input>
      <v-text-field
        v-model="text"
        :disabled="disabled"
        :single-line="singleLine"
        :dense="dense"
        :hide-details="hideDetails"
        :label="label"
        :prepend-icon="
          hideIcon ? '' : type == 'time' ? 'fa-clock' : 'fa-calendar-week'
        "
        @blur="text = model.join(' ~ ')"
        ><template v-slot:append>
          <slot name="switchAction"></slot>
        </template></v-text-field
      >
    </template>
    <template v-slot:icon-calendar>
      <v-icon></v-icon>
    </template>
    <template v-slot:icon-clear>
      <v-icon v-if="!removeIcon">fa-times</v-icon>
      <v-icon v-else></v-icon>
    </template>
    <template v-slot:footer v-if="type == 'datetime'">
      <button
        class="mx-btn mx-btn-text"
        @click="showTimePanel = !showTimePanel"
      >
        {{
          showTimePanel
            ? $t("$datetime.select_date")
            : $t("$datetime.select_time")
        }}
      </button>
    </template>
  </date-picker>
</template>

<script>
import i18n from "@/i18n";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import "./datetime.scss";

if (i18n.locale == "zhHans") require("vue2-datepicker/locale/zh-cn");

const regDate =
  /^[1-9]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1]) ~ [1-9]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])$/;
const regTime =
  /^(20|21|22|23|[0-1]\d):[0-5]\d:[0-5]\d ~ (20|21|22|23|[0-1]\d):[0-5]\d:[0-5]\d$/;
const regMinutes =
  /^(20|21|22|23|[0-1]\d):[0-5]\d ~ (20|21|22|23|[0-1]\d):[0-5]\d$/;
const regHours = /^(20|21|22|23|[0-1]\d) ~ (20|21|22|23|[0-1]\d)$/;
const regDatetime =
  /^[1-9]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])\s+(20|21|22|23|[0-1]\d):[0-5]\d:[0-5]\d ~ [1-9]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])\s+(20|21|22|23|[0-1]\d):[0-5]\d:[0-5]\d$/;

export default {
  name: "DatetimeRangePicker",

  components: { DatePicker },

  props: {
    value: Array,
    label: String,
    type: String,
    singleLine: Boolean,
    dense: Boolean,
    hideDetails: Boolean,
    hideIcon: Boolean,
    hideShortcuts: Boolean,
    disabled: Boolean,
    removeIcon: Boolean,
  },

  data: () => ({
    showTimePanel: false,
    model: [],
    text: "",
  }),

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        this.model = this.value;
      },
    },
    model: {
      immediate: true, //初始赋值也调用
      handler() {
        this.text = this.model.join(" ~ ");
        this.$emit("input", this.model);
      },
    },
    text: {
      handler() {
        var regExp =
          this.type == "datetime"
            ? new RegExp(regDatetime)
            : this.type == "time"
            ? new RegExp(regTime)
            : this.type == "minutes"
            ? new RegExp(regMinutes)
            : this.type == "hours"
            ? new RegExp(regHours)
            : new RegExp(regDate);
        if (regExp.test(this.text)) {
          this.model = this.text.split(" ~ ");
        }
      },
    },
  },
};
</script>
